export default {
  day: 'dia',
  fileSizeLimitTitle:
    'O tamanho do arquivo para conta gratuita não pode exceder 20 MB.',
  freeTimesLimitTitle: 'O teste da conta gratuita termina hoje.',
  total: 'Total',
  enterCode: 'Digitar o código',
  signUpToPurchaseBtn: 'Registrar-se para comprar',
  goPurchseBtn: 'Ir para comprar',
  saveTips: 'Economizar até {{num}}%.',
  discount: 'Desconto',
  weekly: 'Semanalmente',
  montly: 'Mensal',
  yearly: 'Anualmente',
  week: 'Semana',
  priceWeek: 'R$59,99',
  priceMonth: 'R$39,99',
  priceYearly: 'R$19,99',
  billMonth: 'R$159,99 Pagos Mensalmente',
  billYear: 'R$929,99 Pagos Anualmente',
  AlreadySubscribe: 'Já inscrevi?',
  vipTips1: 'Sem limites de tamanho de arquivo',
  vipTips2: 'Processe a quantidade de arquivos sem limites',
  vipTips3: 'Altere os fundos das imagens sem limites',
  vipTips4: 'Acesso a todas as ferramentas gratuitas e recursos premium',
  purchaseTips: 'Renovar automaticamente e cancelar a qualquer momento.',
  tips: 'Dicas:',
  promoCodeInvalidTips: 'Seu código de promoção é inválido',
};
